import React, { useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Paper,
} from '@mui/material';
import { useInView } from 'react-intersection-observer';
import { gsap } from 'gsap';

// MUI Icons
import GroupIcon from '@mui/icons-material/Group'; // 👥
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // 💰
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'; // 
import TrendingUpIcon from '@mui/icons-material/TrendingUp'; // 📈

const StaticsHomeSection = () => {
  const { ref: statsRef, inView: statsInView } = useInView({ triggerOnce: true });
  const statsElements = useRef([]);

  useEffect(() => {
    if (statsInView) {
      gsap.fromTo(
        statsElements.current,
        { y: 50, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, stagger: 0.1, ease: "power2.out" }
      );
    }
  }, [statsInView]);

  const statsData = [
    { number: '15,000+', label: 'Active Users', icon: <GroupIcon sx={{ fontSize: 50, color: '#2D3A27' }} /> },
    { number: '$2.5M+', label: 'Monthly Volume', icon: <AttachMoneyIcon sx={{ fontSize: 50, color: '#2D3A27' }} /> },
    { number: '500+', label: 'Verified Dealers', icon: <VerifiedUserIcon sx={{ fontSize: 50, color: '#2D3A27' }} /> },
    { number: '99.8%', label: 'Success Rate', icon: <TrendingUpIcon sx={{ fontSize: 50, color: '#2D3A27' }} /> },
  ];

  return (
    <Box
      ref={statsRef}
      sx={{
        py: { xs: 5, md: 10 },
        // background: 'linear-gradient(180deg, #fff 0%, rgba(244, 197, 66, 0.02) 100%)',
        background:'#fff',
        position: 'relative',
      }}
    >
      <Container maxWidth="xl">
        {/* Section Title */}
        <Typography
          variant="h3"
          align="center"
          sx={{
            fontWeight: 800,
            mb: 6,
            fontSize: { xs: '2rem', md: '3rem' },
            color: '#2D3A27',
          }}
        >
          Platform Performance Highlights
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {statsData.map((stat, index) => (
            <Grid item xs={6} md={3} key={index}>
              <Paper
                ref={(el) => (statsElements.current[index] = el)}
                sx={{
                  background: 'linear-gradient(135deg, rgba(244, 197, 66, 0.1) 0%, rgba(255, 255, 255, 0.9) 100%)',
                  backdropFilter: 'blur(20px)',
                  borderRadius: '24px',
                  border: '2px solid rgba(244, 197, 66, 0.2)',
                  p: 5,
                  textAlign: 'center',
                  transition: 'all 0.4s ease',
                  height: '200px',
                  width: '250px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  '&:hover': {
                    transform: 'translateY(-10px) scale(1.02)',
                    background: 'linear-gradient(135deg, rgba(244, 197, 66, 0.15) 0%, rgba(255, 255, 255, 0.95) 100%)',
                    boxShadow: '0 30px 60px rgba(244, 197, 66, 0.3)',
                  },
                }}
              >
                <Box mb={2}>{stat.icon}</Box>

                <Typography
                  variant="h2"
                  sx={{
                    color: '#F4C542',
                    fontWeight: 900,
                    mb: 1,
                    fontSize: { xs: '2rem', md: '2.8rem' },
                  }}
                >
                  {stat.number}
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    color: 'rgba(45, 58, 39, 0.8)',
                    fontWeight: 600,
                    fontSize: '1.2rem',
                  }}
                >
                  {stat.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default StaticsHomeSection;
